import { render, staticRenderFns } from "./samples.vue?vue&type=template&id=e1b72198&scoped=true&"
import script from "./samples.vue?vue&type=script&lang=js&"
export * from "./samples.vue?vue&type=script&lang=js&"
import style0 from "./samples.vue?vue&type=style&index=0&id=e1b72198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b72198",
  null
  
)

export default component.exports